<div class="login-wrap">
  <div class="login-card">

    <div class="app-icon">🛒</div>
    <h1 class="login-title">Don't waste</h1>

    @if (!showRequestForm) {

      <p class="login-sub">Voer je familiecode in</p>

      @if (errorText) {
        <div class="status-error">{{ errorText }}</div>
      }

      <mat-form-field appearance="outline" class="code-field">
        <mat-label>Familiecode</mat-label>
        <input matInput [(ngModel)]="code" (keyup.enter)="submit()"
               maxlength="8" autocomplete="off" autocapitalize="characters"
               placeholder="bijv. A3K7M2R9">
      </mat-form-field>

      <button mat-flat-button class="submit-btn" (click)="submit()" [disabled]="loading">
        {{ loading ? 'Zoeken…' : 'Doorgaan' }}
      </button>

      <div class="bottom-links">
        <p class="register-link">
          Nog geen familie? <a routerLink="/register">Registreer hier</a>
        </p>
        <p class="register-link">
          Code kwijt? <a href="#" (click)="$event.preventDefault(); toggleRequestForm()">Familiecode opvragen</a>
        </p>
      </div>

    } @else {

      <p class="login-sub">Familiecode opvragen</p>

      @if (requestStatus) {
        <div [class]="requestIsError ? 'status-error' : 'status-success'">{{ requestStatus }}</div>
      }

      @if (!requestStatus || requestIsError) {
        <div class="request-form">
          <input class="email-input" type="email" [(ngModel)]="requestEmail"
                 placeholder="jouw@emailadres.nl" autocomplete="email"
                 (keyup.enter)="requestCode()">
          <button class="submit-btn" [disabled]="requestLoading || !requestEmail.trim()"
                  (click)="requestCode()">
            {{ requestLoading ? 'Versturen…' : 'Verstuur code' }}
          </button>
        </div>
      }

      <p class="register-link back-link">
        <a href="#" (click)="$event.preventDefault(); toggleRequestForm()">← Terug</a>
      </p>

    }

  </div>
</div>
